import React from 'react';
import SentenceWithLink from './SentenceWithLink';
const WorkText = () => {
    return (
        <div className="work-text">
            <span className='work-expand'>I&apos;m a senior software engineer at Tableau, a Salesforce company. I work in identity and authentication, building features that enable secure integration with Tableau Cloud. Most recently I've worked on Unified Access Token and authentication for Tableau MCP.</span>
            <span className='work-expand'>Previously:</span>
            <div className='work-expand'>
                <SentenceWithLink
                    sentence="Supported the Launch Control System for Artemis I at NASA Kennedy Space Center."
                    replacements={[
                        { customWord: "NASA Kennedy Space Center", url: "https://www.nasa.gov/humans-in-space/nasa-certifies-new-launch-control-system-for-artemis-i/" }
                    ]}
                />
            </div>
            <div className='work-expand'>
                <SentenceWithLink
                    sentence="Led gamification and user engagement features for a large-scale platform focused on identifying misinformation at Public Editor."
                    replacements={[
                        { customWord: "Public Editor", url: "https://www.goodlylabs.org/" }
                    ]}
                />
            </div>
            <div className='work-expand'>
                <SentenceWithLink
                    sentence="Conducted machine learning research on classifying cloud formations at the University of Chicago's Center for Data and Computing."
                    replacements={[
                        { customWord: "University of Chicago's Center for Data and Computing", url: "https://datascience.uchicago.edu/people/ruby-werman/" }
                    ]}
                />
            </div>
            <div className='work-expand'>
                <SentenceWithLink
                    sentence="Contributed to open-source projects including scikit-learn as part of the inaugural class of the MLH Fellowship."
                    replacements={[
                        { customWord: "MLH Fellowship", url: "https://github.blog/2020-06-24-welcome-to-the-inaugural-class-of-mlh-fellows/" }
                    ]}
                />
            </div>
        </div>
    );
};

export default WorkText;
